import { useMemo } from 'react';
import { useAppSelector, useIsMultiPortfolioTenant } from './index';
import { GoalFormField } from '../types';
import { TermTabType } from '../constants';
import { AdviceGoalPayloadType } from '../../features/client-goals';

type GoalField = AdviceGoalPayloadType['formFields'][0];

export const useTermFormFields = (term: TermTabType) => {
    const formFields = useAppSelector((state) => state.adviceGoals?.formFields);
    const isMultiPortfolioTenant = useIsMultiPortfolioTenant();

    const displayedFormFields = useMemo<GoalFormField[]>(() => {
        // AEX-3108: single-portfolio tenants have one default term, so every goal belongs to it.
        if (!isMultiPortfolioTenant) return formFields ?? [];
        return (formFields ?? []).filter((goal: GoalField) => term === goal.data.goalCategoryOrder - 1);
    }, [formFields, term, isMultiPortfolioTenant]);

    return { formFields, displayedFormFields };
};
